import { datadogRum } from "@datadog/browser-rum";
import { pick } from "lodash-es";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";

import Logger from "~/services/logger/logger";
import appRoutes from "~/utils/app-routes";

const datadogViews = Object.fromEntries(
  Object.entries({
    ...pick(appRoutes, [
      "HOMEPAGE",
      "CART",
      "THANKYOU",
      "SIGN_UP",
      "LOGIN",
      "CHECKOUT",
      "CUSTOMER_HELP_CENTER",
      "FAQ_HELP",
      "PASSWORD_RESET_REQUEST",
    ]),
    PDP: "/p/[slug]",
    PLP: "/c/[...category]",
    // Sanitize paths by having them all start by "/"
  }).map(([key, path]) => [`/${path}`.replace("//", "/"), key])
);

export const useDatadogRumStartView = () => {
  const router = useRouter();
  const lastViewRef = useRef<string | null>(null);

  useEffect(() => {
    const viewName = datadogViews[router.pathname];
    const refName = [viewName, router.query.slug || ""].filter(Boolean).join("-");
    Logger.instance.debug(`Datadog RUM view for ${router.pathname}: ${viewName} (ref ${refName})`);
    if (viewName && lastViewRef.current !== refName) {
      datadogRum.startView(viewName);
      lastViewRef.current = refName;
    }
  }, [router.pathname, router.query.slug]);
};
